export function getValueAtPath(
  input: Record<string, unknown>,
  path: string,
): unknown {
  const parts = path.split(".").filter(Boolean);
  let current: unknown = input;

  for (const part of parts) {
    if (typeof current !== "object" || current === null || !(part in current)) {
      return undefined;
    }
    current = (current as Record<string, unknown>)[part];
  }

  return current;
}
